import useSWR from "swr"
import GhostContentAPI from "@tryghost/content-api"

export interface GhostTag {
  id: string
  name: string
  slug: string
  count?: { posts: number }
}

const api = new GhostContentAPI({
  url: process.env.NEXT_PUBLIC_GHOST_HOST,
  key: process.env.NEXT_PUBLIC_GHOST_KEY,
  version: "v3",
})

const fetchGhostTags = (): Promise<GhostTag[]> =>
  api.tags.browse({ limit: "all", include: "count.posts" }) as Promise<GhostTag[]>

export default function useGhostTags(): GhostTag[] {
  const { data } = useSWR<GhostTag[]>("ghost:tags:all", fetchGhostTags, {
    revalidateOnFocus: false,
    dedupingInterval: 60_000,
  })
  return data ?? []
}
